"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.overrideCreator = exports.complete = exports.request = exports.HTTP_OVERRIDE = exports.HTTP_COMPLETE = exports.HTTP_REQUEST = exports.COMPLETE = exports.FAILURE = exports.SUCCESS = exports.REQUEST = void 0;

var _reduxActions = require("redux-actions");

var REQUEST = 'REQUEST';
exports.REQUEST = REQUEST;
var SUCCESS = 'SUCCESS';
exports.SUCCESS = SUCCESS;
var FAILURE = 'FAILURE';
exports.FAILURE = FAILURE;
var COMPLETE = 'COMPLETE';
exports.COMPLETE = COMPLETE;
var HTTP_REQUEST = "HTTP_".concat(REQUEST);
exports.HTTP_REQUEST = HTTP_REQUEST;
var HTTP_COMPLETE = "HTTP_".concat(COMPLETE);
exports.HTTP_COMPLETE = HTTP_COMPLETE;
var HTTP_OVERRIDE = 'HTTP_OVERRIDE';
exports.HTTP_OVERRIDE = HTTP_OVERRIDE;
var request = (0, _reduxActions.createAction)(HTTP_REQUEST);
exports.request = request;
var complete = (0, _reduxActions.createAction)(HTTP_COMPLETE);
exports.complete = complete;

var overrideCreator = function overrideCreator(payloadCreator) {
  return (0, _reduxActions.createAction)(HTTP_OVERRIDE, payloadCreator);
};

exports.overrideCreator = overrideCreator;